import React, { PropTypes } from "react";
import { Route, Switch } from "react-router-dom";

// import ReactDOM from "react-dom";

export default class ViewHelpers {
  constructor() {}

  RouteWithSubRoutes(route) {
    return (
      <Route
        path={route.path}
        render={(
          props // pass the sub-routes down to keep nesting
        ) => <route.component {...props} routes={route.routes} />}
      />
    );
  }

  SubViews = ({ routes }) => {
    return (
      <Switch>
        {routes.map((route, index) => (
          <this.RouteWithSubRoutes key={index} {...route} />
        ))}
      </Switch>
    );
  };
}

// export function RouteWithSubRoutes(route) {
//   return(<Route
//     path={route.path}
//     render={(
//       props // pass the sub-routes down to keep nesting
//     ) => <route.component {...props} routes={route.routes} />}
//   />);
// };
//
// export function SubViews(){
//   return (<Switch>
//   {routes.map((route, index) => (
//     <RouteWithSubRoutes key={index} {...route} />
//   ))}</Switch>);
// }
